import { render, staticRenderFns } from "./Resumo.vue?vue&type=template&id=756e292f&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./Resumo.vue?vue&type=script&lang=js&"
export * from "./Resumo.vue?vue&type=script&lang=js&"
import style0 from "./Resumo.vue?vue&type=style&index=0&id=756e292f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756e292f",
  null
  
)

export default component.exports